import API from '@/util/api/API'
import { LinkResponse, TokenResponse, RegisterRequest } from '@/types/api/ob'
import { APIResponse } from '@/types/api/api'


class OnboardingAPI {
    /**
     * Request an API token
     */
    public async requestToken(email: string, userKeyHash: string): Promise<TokenResponse> {
        return API.post('request-token', { email, user_key_hash: userKeyHash })
    }

    /**
     * Attempt to register the user
     */
    public async register(data: RegisterRequest): Promise<TokenResponse> {
        return API.post('ob/register', data)
    }

    /**
     * Check if the specified username already exists
     */
    public async usernameExists(username: string): Promise<boolean> {
        return (await API.post('ob/check/username', { username })).exists
    }

    /**
     * Check if the specified email already exists
     */
    public async emailExists(email: string): Promise<boolean> {
        return (await API.post('ob/check/email', { email })).exists
    }

    /**
     * Perform a link request
     */
    public async link(email: string, userKeyHash: string): Promise<LinkResponse> {
        return API.post('ob/link', { email, user_key_hash: userKeyHash })
    }

    public async verifyEmail(userId: string, token: string) {
        return API.post('ob/verify', { userId, token })
    }

    public async resendVerification(userId: string): Promise<APIResponse> {
        return API.post('ob/resend', { userId })
    }

    public async revokeTokens(): Promise<APIResponse> {
        return API.delete('token')
    }
}

export default new OnboardingAPI()
